import React, { useState } from "react";
import { SubscriptionType, UpsellPanelSteps } from "../../../constants/upsellPanelEnumsAndConstants";
import useTrackDocDownloadSF from "../../investWithUs/hooks/useTrackDocDownloadSF";
import useGetDownloadDocUrl from "../hooks/useGetDownloadDocUrl";
import useReloadFreePopup from "../hooks/useReloadFreePopup";
import { UpsellWidgetContainerProvider } from "../hooks/useUpsellWidgetContainerContext";
import { useUpsellWidgetModel } from "../hooks/useUpsellWidgetModelContext";
import { EmailDisclosure } from "./EmailDisclosure";
import UpSellWidgetContainer from "./UpSellWidgetContainer";
import { UpsellWidgetRedirectProvider } from "../hooks/useRedirectContext";

const UpSellWidgetCustom = () => {
    const model = useUpsellWidgetModel();
    const [currentStep, setCurrentStep] = useState(model.currentStep || 1);
    const [baseProps, setBaseProps] = useState({        
        user: model.user
    });
    const trackDocDownload = useTrackDocDownloadSF();
    const getDownloadDocUrl = useGetDownloadDocUrl();
    const reloadFreePopup = useReloadFreePopup();

    const onCloseBtnClick = (reload = false) => {
        if ((baseProps.refreshOnClose) && !(currentStep === UpsellPanelSteps.Step13EventThankYou || currentStep === UpsellPanelSteps.Step15PopupThankYou)) {
            window.location.reload();
            return;
        }
        if (typeof model.popupMustLogin !== 'undefined' && !model.popupMustLogin) {
            if (reload) {
                window.location.reload();
            }
            else {
                history.replaceState("", document.title, window.location.pathname + window.location.search);
                if (model.productHandle == SubscriptionType.SUBSCRIPTION_INSIGHTS_FREE_PRODUCT_HANDLE) {
                    sessionStorage.setItem("FreeSignUpLastShown", new Date().getTime());
                    reloadFreePopup();
                }
                return;
            }
        }
        if (reload === undefined) { // using this to fix ie11 issues since they don't support default parameters.
            reload = true;
        }

        if (reload && (currentStep == UpsellPanelSteps.Step13EventThankYou || currentStep == UpsellPanelSteps.Step15PopupThankYou)) {
            if (model.downloadFileId) {
                trackDocDownload(model.downloadFileId);
                window.open(getDownloadDocUrl(model.downloadFileId, model.downloadFileUrl), "_blank");
            }
            window.location.reload();
        } else {
            history.replaceState("", document.title, window.location.pathname + window.location.search);
            if (model.productHandle == SubscriptionType.SUBSCRIPTION_INSIGHTS_FREE_PRODUCT_HANDLE) {
                sessionStorage.setItem("FreeSignUpLastShown", new Date().getTime());
                reloadFreePopup();
            }
        }
    };

    const goToStep = (stepId) => {
        setCurrentStep(stepId);
    };

    return (
        <UpsellWidgetContainerProvider currentStep={currentStep} goToStep={goToStep} onCloseBtnClick={() => onCloseBtnClick(false)} setBaseProps={setBaseProps} baseProps={baseProps}>
            <UpsellWidgetRedirectProvider>
                <UpSellWidgetContainer />
                {/* Conditional Rendering */}
                {!model.hideEmailModal && <EmailDisclosure />}
            </UpsellWidgetRedirectProvider>
        </UpsellWidgetContainerProvider >
    );
};

export default UpSellWidgetCustom;
